import { createClient } from '@supabase/supabase-js';
import { supabaseStorage } from './supabaseStorage';

// Access environment variables securely
// Note: In Vite, env variables must begin with VITE_
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase credentials missing! Check your .env file.');
}

export const supabase = createClient(supabaseUrl || '', supabaseAnonKey || '', {
  auth: {
    // Usar Implicit Flow en lugar de PKCE. 
    // PKCE da problemas si el usuario abre el correo en un dispositivo o navegador distinto
    // al que usó para registrarse (ej. pide registro en Chrome PC, abre email en Safari Móvil).
    // Con Implicit Flow y verifyOtp(token_hash), funciona en cualquier dispositivo.
    flowType: 'implicit',
    persistSession: true,
    autoRefreshToken: true,
    // Mantenemos esto apagado para que la web no intente auto-consumir la sesión,
    // y sea exclusivamente el clic humano en Verified.tsx el que llame a verifyOtp.
    detectSessionInUrl: false,
    storage: supabaseStorage,
  },
});
